// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"136":"d7dec27f1b72e5b9","793":"b842389448eeaadd"}[chunkId] + ".js";
};